import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FeaturesColumn from './featuresColumn';
import { getFeaturesByPath } from 'api';
import { ContainerLoader } from '../'

import * as Actions from 'actions';

class FeaturesContainer extends React.Component {
	constructor(props) {
		super(props);
	}

  componentWillMount() {
  	this.props.beginInitFeaturesTree();
  }

	render() {
		let featuresContainerClassName;
		let numOfColumns;
		let featuresColumnClassName;
		let featureClassName;
		let featuresHeadingOpenClassName;
		let featuresHeadingClosedClassName;
		let parentFeatureWrapperClassName;
		let parentFeatureBodyClassName;
		let nestedFeatureWrapperClassName;
		let nestedFeatureBodyClassName;
		let handleChange;


		if(this.props.featuresContainerClassName) {
			featuresContainerClassName = this.props.featuresContainerClassName;
		}
		else {
			featuresContainerClassName = 'row features-container';
		}
		if(this.props.numOfColumns) {
			numOfColumns = this.props.numOfColumns;
		}
		else {
			numOfColumns = 1;
		}
		if(this.props.featuresColumnClassName) {
			featuresColumnClassName = this.props.featuresColumnClassName;
		}
		else {
			featuresColumnClassName = 'col-md-4 col-sm-12';
		}
		if(this.props.featureClassName) {
			featureClassName = this.props.featureClassName;
		}
		else {
			featureClassName = 'panel';
		}
		if(this.props.featuresHeadingOpenClassName) {
			featuresHeadingOpenClassName = this.props.featuresHeadingOpenClassName;
		}
		else {
			featuresHeadingOpenClassName = 'feature-heading-open';
		}
		if(this.props.featuresHeadingClosedClassName) {
			featuresHeadingClosedClassName = this.props.featuresHeadingClosedClassName;
		}
		else {
			featuresHeadingClosedClassName = 'feature-heading-closed';
		}
		if(this.props.parentFeatureWrapperClassName) {
			parentFeatureWrapperClassName = this.props.parentFeatureWrapperClassName;
		}
		else {
			parentFeatureWrapperClassName = 'parent-feature-wrapper';
		}
		if(this.props.parentFeatureBodyClassName) {
			parentFeatureBodyClassName = this.props.parentFeatureBodyClassName;
		}
		else {
			parentFeatureBodyClassName = 'parent-feature-body';
		}
		if(this.props.nestedFeatureWrapperClassName) {
			nestedFeatureWrapperClassName = this.props.nestedFeatureWrapperClassName;
		}
		else {
			nestedFeatureWrapperClassName = 'nested-feature-wrapper';
		}
		if(this.props.nestedFeatureBodyClassName) {
			nestedFeatureBodyClassName = this.props.nestedFeatureBodyClassName;
		}
		else {
			nestedFeatureBodyClassName = 'nested-feature-body';
		}
		if(this.props.handleChange) {
			handleChange = this.props.handleChange;
		}
		else {
			handleChange = null;
		}

		let features_column_array = [];
		let popoverPosition;

		if(this.props.features.fetching_features) {
			return (
				<div className="container-loader-spinner">
	        <i className="fa fa-spinner fa-spin fa-5x fa-fw"></i>
	        <br/>
	        <span className="loading-text">
	          Loading...
	        </span>
	      </div>
			)
		}
		else {
			return (
				<div className={featuresContainerClassName}>
					{(() => {
						for(let i = 0; i < numOfColumns; i++) {
							if(i == numOfColumns - 1)
								popoverPosition = 'left'
							else
								popoverPosition = 'right'

							features_column_array.push(
								<div
									key={i}
									className={featuresColumnClassName}>
									<FeaturesColumn
										numOfColumns={numOfColumns}
										index={i}
										featureClassName={featureClassName}
										featuresHeadingOpenClassName={featuresHeadingOpenClassName}
										featuresHeadingClosedClassName={featuresHeadingClosedClassName}
										parentFeatureWrapperClassName={parentFeatureWrapperClassName}
										parentFeatureBodyClassName={parentFeatureBodyClassName}
										nestedFeatureWrapperClassName={nestedFeatureWrapperClassName}
										nestedFeatureBodyClassName={nestedFeatureBodyClassName}
										handleChange={handleChange}
										popoverPosition={popoverPosition}
										current_entity={this.props.current_entity}
									/>
								</div>
							)
						}
						return features_column_array.map(f => f);
					})()}
				</div>
			)
		}
	}
}

let mapStateToProps = ({ features }) => ({ features })

export default connect(mapStateToProps, Actions)(FeaturesContainer)



// WEBPACK FOOTER //
// ./src/browser/components/features/featuresContainer.js